import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const markdownSlotRecipe = defineSlotRecipe({
  className: 'markdown',
  slots: ['root', 'blockquote'],
  base: {
    blockquote: {
      borderInlineStart: '2px solid',
      borderColor: 'border/regular',
      paddingInlineStart: '16',
      paddingBlock: '8',
      color: 'text/secondary',
    },
  },
  variants: {
    size: {
      sm: {
        root: {
          textStyle: 'body/sm/regular',
        },
      },
      md: {
        root: {
          textStyle: 'body/md/regular',
        },
      },
      lg: {
        root: {
          textStyle: 'body/lg/regular',
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export default markdownSlotRecipe;
